export default function accountFactory() {
  // Assert that the BSCS is ubiquitous and always available
  const BSCS = window.adacado.bscs

  // Get unique token from BSCS as part of initialization
  const bsiInstanceID = BSCS.getToken()

  return {
    // Registration related functions
    register(account) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'POST',
        requestPath: `/account/v2/register`,
        requestParameters: [],
        payload: account,
      })
    },
    create(account) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'POST',
        requestPath: `/account/v2/create`,
        requestParameters: [],
        payload: account
      })
    },
    get(callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/retrieve`,
        requestParameters: [],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    registered(email, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/registered/:email`,
        requestParameters: [
          { key: 'email', value: window.btoa(email) }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    // individual account related function
    update(account) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'PUT',
        requestPath: `/account/v2/update`,
        payload: account
      })
    },
    // Team management functions
    initTeamObject() {
      return {
        TeamID: 0,
        Name: 'New team',
        Description: '',
        LastUpdated: 0,
        CreationDate: 0,
      }
    },
    retrieveTeam(teamID, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/team/retrieve/:tid`,
        requestParameters: [
          { key: 'tid', value: teamID }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    createTeam(team) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'POST',
        requestPath: `/account/v2/team/create`,
        requestParameters: [],
        payload: team,
      })
    },
    updateTeam(team) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'PUT',
        requestPath: `/account/v2/team/update/:tid`,
        payload: team,
        requestParameters: [
          { key: 'tid', value: team.TeamID }
        ],
      })
    },
    deleteTeam(teamID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'DELETE',
        requestPath: `/account/v2/team/delete/:tid`,
        requestParameters: [
          { key: 'tid', value: teamID }
        ],
      })
    },
    /*
    member object:
    */
    initMemberObject() {
      return {
        accountId: 0,
        Role: ['BillingAccountAssociate'],
        TeamID: 0,
      }
    },
    addTeamMember(member) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'POST',
        requestPath: `/account/v2/team/addmember`,
        payload: member,
      })
    },
    /*
    Allowed values for role are:
    * TeamManager
    * BillingAccountAssociate
    */
    updateMemberRole(accountID,member){
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'PUT',
        requestPath: `/account/v2/team/updatememberrole/:aid`,
        requestParameters: [
          { key: 'aid', value: accountID }
        ],
        payload: member
      })
    },
    removeTeamMember(teamID, accountID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'DELETE',
        requestPath: `/account/v2/team/removemember/:tid`,
        requestParameters: [
          { key: 'tid', value: teamID }
        ],
        payload: accountID,
      })
    },
    listTeamMembers(teamID, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/team/listmembers/:tid`,
        requestParameters: [
          { key: 'tid', value: teamID }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    listTeams(callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/team/list`,
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    listTeamMemberCandidates(callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/team/listmembercandidates`,
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    retrieveAccountDetails(accountID, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/accounts/retrieveaccountdetails/:aid`,
        requestParameters: [
          { key: 'aid', value: accountID }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    // Account management system functions:
    listAccounts(accessCheckOnly=false, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: BSCS.accessPathRewrite(`/account/v2/accounts/list`, accessCheckOnly),
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    disableAccount(accountID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'PUT',
        requestPath: `/account/v2/accounts/disable/:aid`,
        requestParameters: [
          { key: 'aid', value: accountID }
        ]
      })
    },
    enableAccount(accountID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'PUT',
        requestPath: `/account/v2/accounts/enable/:aid`,
        requestParameters: [
          { key: 'aid', value: accountID }
        ]
      })
    },
    /* allowed values for role in which role is an array of roles
      * BillingAccountManager
      * BillingAccountAssociate
      * BillingAccountOwner
      * TeamsManager
    */
    updateAccountRole(accountID, role) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'PUT',
        requestPath: `/account/v2/accounts/updateaccountrole/:aid`,
        requestParameters: [
          { key: 'aid', value: accountID }
        ],
        payload: role
      })
    },
    /*
    invite json:
    * InviteExpiryInDays: Value from 1 to 14 days
    */
    initInviteObject() {
      return {
        FirstName: '',
        LastName: '',
        Email: '',
        InviteExpiryInDays: 7,
        Role: ['BillingAccountAssociate'],
      }
    },
    inviteAccount(inviteObject) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'POST',
        requestPath: `/account/v2/accounts/invite`,
        payload: inviteObject
      })
    },
    requestInviteObject(inviteID, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/accounts/requestinviteobject/:iid`,
        requestParameters: [
          { key: 'iid', value: inviteID }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    acceptInvite(inviteID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'PUT',
        requestPath: `/account/v2/accounts/acceptinvite/:iid`,
        requestParameters: [
          { key: 'iid', value: inviteID }
        ]
      })
    },
    cancelInvite(accountID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'DELETE',
        requestPath: `/account/v2/accounts/cancelinvite/:aid`,
        requestParameters: [
          { key: 'aid', value: accountID }
        ]
      })
    },
    resendInvite(accountID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'PUT',
        requestPath: `/account/v2/accounts/resendinvite/:aid`,
        requestParameters: [
          { key: 'aid', value: accountID }
        ]
      })
    },
    canBeInvited(emailAddress, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/accounts/canbeinvited/:email`,
        requestParameters: [
          { key: 'email', value: btoa(emailAddress) }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    /*
      Returns an array of roles (strings)
    */
    listRoles(accountID, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/accounts/listroles/:aid`,
        requestParameters: [
          { key: 'aid', value: accountID }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    listActiveShares(advertiserID, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: `/account/v2/accounts/listactiveshares/:ai`,
        requestParameters: [
          { key: 'ai', value: advertiserID }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }
      })
    },
    listPossibleShares(accessCheckOnly=false, advertiserID, callback) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'GET',
        requestPath: BSCS.accessPathRewrite(`/account/v2/accounts/listpossibleshares/:ai`,accessCheckOnly),
        requestParameters: [
          { key: 'ai', value: advertiserID }
        ],
        callback: (account, token, annotation) => {
          callback(account, true, annotation)
        }           
      })
    },
    addShare(accessCheckOnly=false, advertiserID, accountID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'POST',
        requestPath: BSCS.accessPathRewrite(`/account/v2/accounts/addshare`,accessCheckOnly),
        payload: {
          AdvertiserID: advertiserID,
          AccountID: accountID
        }
      })
    },
    removeShare(advertiserID, accountID) {
      return BSCS.doRequest({
        token: bsiInstanceID,
        requestMethod: 'DELETE',
        requestPath: `/account/v2/accounts/removeshare/:ai`,
        requestParameters: [
          { key: 'ai', value: advertiserID }
        ],
        payload: {
          AccountID: accountID
        }
      })
    },
  }
}